import React from 'react'
import { FiSearch } from 'react-icons/fi'

export default function BranchSearchInput({ value, onChange, onKeyDown, placeholder = 'Search branches...' }) {
  return (
    <div className='branch-search-wrapper'>
      <FiSearch className='search-icon' />
      <input
        type='text'
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
      />
    </div>
  )
}
